import { useTranslation } from '@web_opxp/features';
import some from 'lodash/some';
import * as React from 'react';
import Calendar, { TileClassNameFunc } from 'react-calendar';
import type { OnArgs } from 'react-calendar/dist/cjs/shared/types';
import { isTimestampInDay } from '../../base/dateUtils';
import ChevronLeftIcon from '../icons/ChevronLeftIcon';
import ChevronRightIcon from '../icons/ChevronRightIcon';
import './ProgressCalendar.scss';

export interface IProgressCalendarData {
  timestamp: number;
}

export interface IProgressCalendarProps {
  startTimestamp?: number;
  data: IProgressCalendarData[];
  className?: string;
  onNavigate?: (startTimestamp: number) => void;
}

export const ProgressCalendar: React.FC<IProgressCalendarProps> = ({ startTimestamp, data, onNavigate, className }) => {
  const { language } = useTranslation();
  const startDate = startTimestamp ? new Date(startTimestamp) : undefined;

  const onViewChange = ({ activeStartDate }: OnArgs) => {
    if (onNavigate) onNavigate(activeStartDate ? activeStartDate.getTime() : 0);
  };
  const tileContent = () => {
    // We can add a tooltip here later if needed
    return '';
  };
  const formatDay = (locale: string | undefined, date: Date) => {
    // Remove day numbers
    return '';
  };
  const getTileClassName: TileClassNameFunc = ({ date }) => {
    // Mark the day if it is among the workout days
    return some(data, ({ timestamp }) => isTimestampInDay(timestamp, date)) ? 'has-workout' : '';
  };
  return (
    <div className={`progressCalendar ${className ?? ''}`}>
      <Calendar
        className={'progress-calendar'}
        tileClassName={getTileClassName}
        formatDay={formatDay}
        nextLabel={<ChevronRightIcon className="next-month-icon" />}
        prevLabel={<ChevronLeftIcon className="prev-month-icon" />}
        showNeighboringMonth={false}
        locale={language}
        tileContent={tileContent}
        maxDetail={'month'}
        minDetail={'month'}
        onViewChange={onViewChange}
        onActiveStartDateChange={onViewChange}
        activeStartDate={startDate}
      />
    </div>
  );
};

export default ProgressCalendar;
